import React from 'react';
import { Tag } from 'antd';

import { RightSidebar } from "src/pages/_partials/Layout";
import { PhoneNumberPriceInterface } from "src/store/callrecorder/phoneNumberPricesSlice";
import RowInfo from "src/componets/RowInfo";
import { formattedDate } from "src/helpers/DateHelpers";

const boolTag = (val: boolean) =>
  val ? <Tag color="success">yes</Tag> : <Tag color="default">no</Tag>;

const _SidebarShow = ({ record }: { record: PhoneNumberPriceInterface | undefined }) => {
  const renderDetails = () => {
    if (!record) {
      return null;
    }

    return (
      <>
        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Base Information</h6>

          <RowInfo left='#ID' right={record.id} />
          <RowInfo left='Country' right={record.country_code} />
          <RowInfo left='Prefix' right={`+${record.prefix}`} />
          <RowInfo left='Type' right={record.phone_number_type} />
          <RowInfo left='Currency' right={record.currency} />
          <RowInfo left='Provider' right={`#${record.provider_id}`} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Sell Prices</h6>

          <RowInfo left='Monthly Fee' right={record.monthly_fee} />
          <RowInfo left='Setup Fee' right={record.setup_fee} />
          <RowInfo left='Inbound Call' right={record.inbound_cost_per_min || '—'} />
          <RowInfo left='Inbound SMS' right={record.inbound_sms_price || '—'} />
          <RowInfo left='Inbound MMS' right={record.inbound_mms_price || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Raw Provider Prices</h6>

          <RowInfo left='Raw Monthly' right={record.raw_monthly_fee || '—'} />
          <RowInfo left='Raw Trunking' right={record.raw_inbound_trunking_price || '—'} />
          <RowInfo left='Raw SMS' right={record.raw_inbound_sms_price || '—'} />
          <RowInfo left='Raw MMS' right={record.raw_inbound_mms_price || '—'} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Capabilities</h6>

          <RowInfo left='Trunking' right={boolTag(record.trunking_enabled)} />
          <RowInfo left='SMS' right={boolTag(record.sms_enabled)} />
          <RowInfo left='MMS' right={boolTag(record.mms_enabled)} />
          <RowInfo left='Address Req' right={boolTag(record.address_required)} />
          <RowInfo left='Beta' right={boolTag(record.beta)} />
        </div>

        <div className='v-mb-20'>
          <h6 className='v-content-label o-sm'>Dates</h6>

          <RowInfo left='Last Synced' right={record.last_synced_at ? formattedDate(record.last_synced_at).dateTime : '—'} />
          <RowInfo left='Created' right={formattedDate(record.created_at).dateTime} />
          <RowInfo left='Updated' right={formattedDate(record.updated_at).dateTime} />
        </div>
      </>
    )
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>PRICE DETAILS</h6>
      <hr className="v-divider" />

      {renderDetails()}
    </RightSidebar>
  )
}

export default _SidebarShow;
